class DeepUnavailabilityReasonsVisitor {
    constructor(predicate) {
        this.predicate = predicate;
        this.result = false;
    }
    visitGeneric(availability) {
        this.result || (this.result = availability.unavailabilityReasons.some(this.predicate));
    }
    visitAvailable(_) {
        // NOTICE Intentionaly empty
    }
    visitUnavailable(availability) {
        this.visitGeneric(availability);
    }
    visitMaybe(availability) {
        this.visitGeneric(availability);
    }
    visitAsync(availability) {
        this.visitGeneric(availability);
    }
    visitBoolean(availability) {
        this.visitGeneric(availability);
    }
    visitComposite(availability) {
        for (const child of availability.availabilities) {
            if (this.result) {
                return;
            }
            child.accept(this);
        }
    }
    visitDependent(availability) {
        this.visitGeneric(availability);
        availability.dependency.accept(this);
    }
    visitParametrized(availability) {
        this.visitGeneric(availability);
    }
    visitPreorder(availability) {
        this.visitGeneric(availability);
    }
}
export function deepHasUnavailabilityReason(reason, availability) {
    const visitor = new DeepUnavailabilityReasonsVisitor((unavailabilityReason) => unavailabilityReason === reason);
    availability.accept(visitor);
    return visitor.result;
}
